'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ARGUMENTS = exports.ARGUMENTS = '[object Arguments]';
var ARRAY = exports.ARRAY = '[object Array]';
var ARRAY_BUFFER = exports.ARRAY_BUFFER = '[object ArrayBuffer]';
var DATA_VIEW = exports.DATA_VIEW = '[object DataView]';
var DATE = exports.DATE = '[object Date]';
var ERROR = exports.ERROR = '[object Error]';
var FLOAT_32_ARRAY = exports.FLOAT_32_ARRAY = '[object Float32Array]';
var FLOAT_64_ARRAY = exports.FLOAT_64_ARRAY = '[object Float64Array]';
var GENERATOR = exports.GENERATOR = '[object GeneratorFunction]';
var INT_8_ARRAY = exports.INT_8_ARRAY = '[object Int8Array]';
var INT_16_ARRAY = exports.INT_16_ARRAY = '[object Int16Array]';
var INT_32_ARRAY = exports.INT_32_ARRAY = '[object Int32Array]';
var MAP = exports.MAP = '[object Map]';
var MATH = exports.MATH = '[object Math]';
var OBJECT = exports.OBJECT = '[object Object]';
var PROMISE = exports.PROMISE = '[object Promise]';
var REGEXP = exports.REGEXP = '[object RegExp]';
var SET = exports.SET = '[object Set]';
var STRING = exports.STRING = '[object String]';
var UINT_8_ARRAY = exports.UINT_8_ARRAY = '[object Uint8Array]';
var UINT_8_CLAMPED_ARRAY = exports.UINT_8_CLAMPED_ARRAY = '[object Uint8ClampedArray]';
var UINT_16_ARRAY = exports.UINT_16_ARRAY = '[object Uint16Array]';
var UINT_32_ARRAY = exports.UINT_32_ARRAY = '[object Uint32Array]';
var WEAKMAP = exports.WEAKMAP = '[object WeakMap]';
var WEAKSET = exports.WEAKSET = '[object WeakSet]';
var BOOLEAN_TYPEOF = exports.BOOLEAN_TYPEOF = 'boolean';
var FUNCTION_TYPEOF = exports.FUNCTION_TYPEOF = 'function';
var NUMBER_TYPEOF = exports.NUMBER_TYPEOF = 'number';
var STRING_TYPEOF = exports.STRING_TYPEOF = 'string';
var SYMBOL_TYPEOF = exports.SYMBOL_TYPEOF = 'symbol';
var UNDEFINED_TYPEOF = exports.UNDEFINED_TYPEOF = 'undefined';
var DEFAULT_MAX_DEPTH = exports.DEFAULT_MAX_DEPTH = 6;
var DEFAULT_ARRAY_MAX_LENGTH = exports.DEFAULT_ARRAY_MAX_LENGTH = 50;
var DEFAULT_PRUNED_VALUE = exports.DEFAULT_PRUNED_VALUE = '*Recursive';
var ESCAPABLE = exports.ESCAPABLE = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
var META = exports.META = {
  // table of character substitutions
  '\b': '\\b',
  '\t': '\\t',
  '\n': '\\n',
  '\f': '\\f',
  '\r': '\\r',
  '"': '\\"',
  '\\': '\\\\'
};
var HTML_ELEMENT_REGEXP = exports.HTML_ELEMENT_REGEXP = /\[object (HTML(.*)Element)\]/;
var MATH_OBJECT = exports.MATH_OBJECT = ['E', 'LN2', 'LN10', 'LOG2E', 'LOG10E', 'PI', 'SQRT1_2', 'SQRT2'].reduce(function (mathObject, property) {
  return _extends({}, mathObject, _defineProperty({}, property, Math[property]));
}, {});